import React, { useState,useContext } from 'react';
import Parse from 'parse';
import swal from 'sweetalert';
import CounsellorSidebar from '../sidebar/sidebar';
import { Redirect } from 'react-router-dom';
import { AuthContext } from '../../../auth'



const Query = () => {

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [query, setQuery] = useState('');
    let [logedinuser, setLogedinuser] = useContext(AuthContext)


    const handleSubmit = (e) => {
        e.preventDefault();
        // console.log(e)
        // const f = () => {

        // }
        // f();
        const Queries = Parse.Object.extend('Queries');
        const queries = new Queries();

        queries.set("name", name);
        queries.set("email", email);
        queries.set("query", query);
        queries.set("counsellorId",logedinuser);
        queries.set("isCounsellor", true);

        queries.save()
            .then((data) => {
                console.log(data);
                swal("Addedd!", "Your query has been shared with aur team..we will be contacting you shortly", "success");
                setName("");
                setEmail("");
                setQuery("");
            }).catch((error) => {
                console.log(error);
                swal("Oops!", "Seems like we couldn't share your query with the team...Please try again in sometime", "error");

            })

    }
    return (
        <div>
            {(logedinuser == null) && (
                <Redirect to="/counsellor/login" />
            )}
            <CounsellorSidebar head="Your Query"></CounsellorSidebar>
            <div className="container mt-4">
                <form onSubmit={handleSubmit}>


                    <div className="form-group col-lg-12  ">
                        <input
                            type="text"
                            className="form-control"
                            value={name}
                            onChange={e => setName(e.target.value)}
                            placeholder="Name" />
                    </div>
                    <div className="form-group col-lg-12  ">
                        <input
                            type="text"
                            className="form-control"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            placeholder="email id" />
                    </div>
                    <div className="form-group col-lg-12  ">
                        <textarea
                            className="text-box querybox"
                            value={query}
                            onChange={e => setQuery(e.target.value)}
                            placeholder="Query" />
                    </div>
                    <div className="btndiv">
                        <input
                            type="submit"
                            className="submit btn-primary center-block mt-4" />
                    </div>
                </form>
            </div>
        </div>
    )
}
export default Query;